import {Component, Input, OnInit} from '@angular/core';
import {PrimengDropdownOptionInterface} from '@sharedcommon/interfaces/primeng-dropdown-option.interface';
import { PrimengTableService } from '../primeng-table.service';
import { PrimengTableCols } from '@sharedcommon/interfaces/primeng-table-cols';

@Component({
  selector: 'neq-primeng-table-select-filter',
  templateUrl: './primeng-table-select-filter.component.html'
})
export class PrimengTableSelectFilterComponent implements OnInit {

  /**
   * Column identifier.
   */
  @Input() field: string;

  /**
   * List of the filter's options for the current column
   */
  @Input() filterOptions: PrimengDropdownOptionInterface[];

  /**
   * the col to filter
   */
  @Input() col: PrimengTableCols;

  ngOnInit(): void {
    // Required
  }

  /**
   * Apply the filter after a selection
   *
   * @param event
   * @param filter
   * @param dataTableFilter
   */
  applySelectFilter(event, filter, dataTableFilter) {
    if (event) {
      this.applySelectFilterValue(event.value, filter, dataTableFilter);
    } else {
      this.clearFilter(dataTableFilter);
    }
  }

  applySelectFilterValue(value: any, filter, dataTableFilter): void {
    if (value !== undefined) {
      filter(value);
      dataTableFilter.overlayVisible = false;
      dataTableFilter.dt.cd.markForCheck();
    } else {
      this.clearFilter(dataTableFilter);
    }
  }

  clearFilter(dataTableFilter): void {
    dataTableFilter.clearFilter() ;
    dataTableFilter.overlayVisible = false;
  }

  returnFilterType(): void {
    PrimengTableService.returnFilterConf(this.col, 'type');
  }
}
